import { render, staticRenderFns } from "./ReportGlobalvalueStore.vue?vue&type=template&id=68d0b576&scoped=true&"
import script from "./ReportGlobalvalueStore.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueStore.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueStore.vue?vue&type=style&index=0&id=68d0b576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0b576",
  null
  
)

export default component.exports